import { useState, useEffect } from "react";

import React from "react";
import { Button, Card } from "react-bootstrap";
import BannersTable from "./BannersTable";
import BannersModal from "./BannersModal";

import axios from "axios";
import Loader from "../../components/Loader";
import { getHostName } from "../../helpers/utils";

const Banners = () => {
  const hostname = getHostName();

  const [dataList, setDataList] = useState([]);

  const [loader, setLoader] = React.useState(false);

  const [payload, setPayload] = React.useState({});

  //  modal
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    getDataList();
  }, []);

  const getDataList = () => {
    axios
      .get(`${hostname}/api/banners50/get-all-banners50`)
      .then((res) => {
        console.log(res.data);
        setDataList(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const createEntry = () => {
    let obj = {};
    obj.loadType = "Upload Banner";

    setPayload({ ...obj });
    handleShow();
  };

  const viewEntry = (obj) => {
    obj.loadType = "View Banner";

    setPayload({ ...obj });
    handleShow();
  };

  const updateEntry = (obj) => {
    obj.loadType = "Update Banner";

    setPayload({ ...obj });
    handleShow();
  };

  const deleteEntry = (obj) => {
    obj.loadType = "Delete Banner";

    setPayload({ ...obj });
    handleShow();
  };

  if (loader) {
    return <Loader />;
  } else {
    return (
      <div>
        <Card>
          <Card.Body className="overflow-hidden" style={{ minHeight: "90vh" }}>
            <div
              style={{ display: "flex", justifyContent: "space-between" }}
              className="mb-3"
            >
              <h4>Banners50</h4>

              <Button variant="primary" size="sm" onClick={createEntry}>
                + Add
              </Button>
            </div>

            <br />
            <BannersTable
              list={dataList}
              viewEntry={viewEntry}
              updateEntry={updateEntry}
              deleteEntry={deleteEntry}
            />
            <br />

            <BannersModal
              show={show}
              handleClose={handleClose}
              payload={payload}
              setPayload={setPayload}
              getAllData={getDataList}
              hostname={hostname}
            />
          </Card.Body>
        </Card>
      </div>
    );
  }
};

export default Banners;
